import {bzApi, platformApi, bzMetaboApi} from "@/axios";

export function addBzMetaboProject(data) {
    return bzMetaboApi ({
        url: '/projects/add',
        method: 'post',
        data:data
    })
}
export function bzMetaboProjectPage(params,data) {
    return bzMetaboApi ({
        url: '/projects/page',
        method: 'post',
        params:params,
        data:data
    })
}
export function bzMetaboProjectRemarkEdit(id,data) {
    return bzMetaboApi ({
        url: '/projects/edit/remark/'+id,
        method: 'put',
        data:data,
        headers: {
            'Content-Type': 'text/plain'
        }
    })
}
export function bzMetaboProjectCustomerRemarkEdit(id,data) {
    return bzMetaboApi ({
        url: '/projects/edit/customer-remark/'+id,
        method: 'put',
        data:data,
        headers: {
            'Content-Type': 'text/plain'
        }
    })
}
export function bzMetaboProjectChangeUser(data) {
    return bzMetaboApi ({
        url: '/projects/edit/personnel',
        method: 'put',
        data:data,
    })
}
export function editBzMetaboProject(data) {
    return bzMetaboApi({
        url: '/projects/edit',
        method: 'put',
        data: data
    })
}
export function bzMetaboProjectDel(ids) {
    return bzMetaboApi({
        url: '/projects/' + ids,
        method: 'delete'
    })
}
export function projectLast_10_bzMetabo(){
    return bzMetaboApi({
        url: '/projects/last-10',
        method: 'post',
        data:{}
    })
}
